import React from "react";
import { formatPlAmount } from "../../utils/formatPlAmount";

export interface CashInOutInsightsProps {
  title: string;
  body: string;
  lastClosedLabel: string;
  inAmount: number | null;
  outAmount: number | null;
  netAmount: number | null;
  sentiment?: "positive" | "neutral" | "negative";
}

const sentimentLabel = {
  neutral: "Neutral",
  positive: "Positive",
  negative: "Negative",
} as const;

export function CashInOutInsights({
  title,
  body,
  lastClosedLabel,
  inAmount,
  outAmount,
  netAmount,
  sentiment = "neutral",
}: CashInOutInsightsProps) {
  const isPositive = sentiment === "positive";
  const isNegative = sentiment === "negative";

  const netIsPositive =
    typeof netAmount === "number" ? netAmount >= 0 : !isNegative;

  const formattedIn =
    typeof inAmount === "number" ? formatPlAmount(inAmount) : "—";
  const formattedOut =
    typeof outAmount === "number" ? formatPlAmount(outAmount) : "—";
  const formattedNet =
    typeof netAmount === "number"
      ? `${netAmount >= 0 ? "+" : ""}${formatPlAmount(netAmount)}`
      : "—";

  return (
    <div className="flex w-full flex-col items-start justify-between self-stretch">
      <div className="flex flex-col items-start gap-3">
        <span className="text-heading-3 font-heading-3 text-default-font">
          {title}
        </span>
        <span className="text-body font-body text-neutral-600 pb-3">
          {body}
        </span>
      </div>
      <div className="flex w-full flex-col items-start gap-3 rounded-lg border border-solid border-neutral-100 bg-white px-4 py-3 shadow-sm">
        <span className="text-caption font-caption text-neutral-500 uppercase tracking-wide">
          {lastClosedLabel}
        </span>
        <div className="flex w-full items-end justify-between">
          <div className="flex flex-col items-start gap-0.5">
            <span className="text-caption font-caption text-neutral-500">
              in
            </span>
            <span className="text-heading-3 font-heading-3 text-[#059669]">
              {formattedIn}
            </span>
          </div>
          <div className="flex flex-col items-start gap-0.5">
            <span className="text-caption font-caption text-neutral-500">
              out
            </span>
            <span className="text-heading-3 font-heading-3 text-[#dc2626]">
              {formattedOut}
            </span>
          </div>
          <div className="flex flex-col items-start gap-0.5">
            <span className="text-caption font-caption text-neutral-500">
              net
            </span>
            <span
              className={`text-heading-3 font-heading-3 ${netIsPositive ? "text-[#059669]" : "text-[#dc2626]"}`}
            >
              {formattedNet}
            </span>
          </div>
        </div>
      </div>
      <div className="flex items-center gap-2 pt-3">
        {/* <div
          className={`flex h-2 w-2 flex-none flex-col items-start rounded-full ${isPositive ? "bg-success-500" : isNegative ? "bg-error-500" : "bg-neutral-400"}`}
        /> */}
        {/* <span
          className={`text-caption-bold font-caption-bold uppercase tracking-widest ${isPositive ? "text-success-600" : isNegative ? "text-error-600" : "text-neutral-500"}`}
        >
          {sentimentLabel[sentiment]}
        </span> */}
      </div>
    </div>
  );
}
